module.exports = {
  theme: {
    extend: {}
  }
};
